import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { getProjectOptions } from '@/module/Author/Project';
import { ProjectEdit } from '@/module/Author/Project/ProjectEdit';

export const Route = createFileRoute('/_auth/author/_author/project/_project/$projectId/_layout/edit')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { projectId } = Route.useParams();
  const { data: project } = useSuspenseQuery(getProjectOptions(projectId));

  return <ProjectEdit project={project} />;
}
